import { createFileRoute, useLoaderData } from "@tanstack/react-router";

import { orgApiClient } from "@/libs/api";

import { CreateEventPage } from "./-components/create-event.page";

export const Route = createFileRoute("/org/$orgId/event/create")({
  component: Page,
  loader: async ({ params }) => {
    const org = await orgApiClient.getFullDetail(params.orgId);
    return { data: { org } };
  }
});

function Page() {
  const {
    data: { org }
  } = useLoaderData({ from: "/org/$orgId/event/create" });
  if (!org) {
    return <div>Organization not found</div>;
  }

  return <CreateEventPage org={org} />;
}
